var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('span',{staticClass:"faux-button text-primary border border-primary rounded btn btn-outline-primary",attrs:{"title":"Select all"},on:{"click":_vm.click}},[(_vm.checked)?_c('i',{staticClass:"far fa-check-square"}):_c('i',{staticClass:"far fa-square"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }